export default [
  {
    path: "/seo/agent-performance/:agentCode?/:domain?",
    props: true,
    name: "seo-agent-performance",
    component: () => import("@/views/seo/AgentPerformance.vue"),
    meta: {
      pageTitle: "SERP Agent Performance",
      action: "view",
      resource: "seo-agent-performance",
      breadcrumb: [
        {
          text: "SEO",
          active: false
        },
        {
          text: "Agent Performance",
          active: true
        }
      ]
    }
  },
  {
    path: "/seo/google-search-console/:agentCode?/:domain?",
    props: true,
    name: "seo-google-search-console",
    component: () => import("@/views/seo/GoogleSearchConsole.vue"),
    meta: {
      pageTitle: "Google Search Console",
      action: "view",
      resource: "seo-google-search-console",
      breadcrumb: [
        {
          text: "SEO",
          active: false
        },
        {
          text: "Google Search Console",
          active: true
        }
      ]
    }
  },
  {
    path: "/seo/keyword",
    name: "seo-keyword",
    component: () => import("@/views/seo/KeywordAnalysis.vue"),
    meta: {
      pageTitle: "SERP Keyword Analysis",
      action: "view",
      resource: "seo-keyword",
      breadcrumb: [
        {
          text: "SEO",
          active: false
        },
        {
          text: "Keyword Analysis",
          active: true
        }
      ]
    }
  },
  {
    path: "/seo/configuration",
    name: "seo-configuration",
    component: () => import("@/views/seo/Configuration.vue"),
    meta: {
      pageTitle: "SEO Configuration",
      action: "view",
      resource: "seo-configuration",
      breadcrumb: [
        {
          text: "Dashboard",
          active: false,
          to: { name: `dashboard` }
        },
        {
          text: "SEO",
          active: true
        },
        {
          text: "Configuration",
          active: true
        }
      ]
    }
  },
];
